import { SelectDesignTokens } from '@primeuix/themes/types/select';

export const select: SelectDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        borderColor: '{content.borderColor}',
        hoverBorderColor: '{surface.0}',
        paddingX: '10px',
        paddingY: '10px',
        borderRadius: '8px',
        background: '{blue.400}',
        filledBackground: '{blue.400}',
      },
      overlay: {
        background: '{blue.400}',
        borderColor: '{content.borderColor}',
      },
      option: {
        focusBackground: '{blue.300}',
      },
    },
  },
};
